import { create } from "zustand";
import { api } from "./api";

export interface ActiveCall {
  id: string;
  role: "caller" | "callee";
  name: string;
}
interface CallState {
  call: ActiveCall | null;
  error: string | null;
  /** Ring a contact who has an account here. */
  dial: (contactId: string, name: string) => Promise<void>;
  /** Answer an incoming call. */
  answer: (id: string, name: string) => Promise<void>;
  clear: () => void;
}

export const useCall = create<CallState>((set, get) => ({
  call: null,
  error: null,
  async dial(contactId, name) {
    if (get().call) return;
    set({ error: null });
    try {
      const r = await api<{ id: string }>("/assistant/calls", {
        method: "POST",
        body: { contactId },
      });
      set({ call: { id: r.id, role: "caller", name } });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : String(e) });
    }
  },
  async answer(id, name) {
    if (get().call) return;
    set({ error: null });
    try {
      await api(`/assistant/calls/${id}/accept`, { method: "POST", body: {} });
      set({ call: { id, role: "callee", name } });
    } catch (e) {
      set({ error: e instanceof Error ? e.message : String(e) });
    }
  },
  clear: () => set({ call: null }),
}));
